<template>
  <div id="software-form-app" class="rental__registerform">
    <div class="loading-overlay" v-if="loading">
      <div class="loading-ring"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
    <transition name="component-fade" mode="out-in">
    <Component
      :is="step"
      :registerform="registerform"
      :stepOneDecision="stepOneDecision"
      :privacyPage="privacyPage"
      :showPagination="showPagination"
      :errorMessage="errorMessage"
      @setLoading="loading = $event"
      @setDecision="stepOneDecision = $event"
      @updateStep="step = $event"
      @updateForm="registerform = { ...registerform, ...$event }"
      @handleRequest="handleRequest()" />
    </transition>
  </div>
</template>

<script>
import StepOne from './components/Steps/StepOne.vue'
import StepTwo from './components/Steps/StepTwo.vue'
import StepThree from './components/Steps/StepThree.vue'
import Error from './components/Steps/Error.vue'
import axios from 'axios'

export default {
  name: 'App',
  data () {
    return {
      loading: false,
      step: 'StepOne',
      license: 1,
      privacyPage: window.tx_rental.privacyPage,
      successPage: window.tx_rental.successPage,
      typo3ApiBase: window.tx_rental.typo3ApiBase,
      errorMessage: [],
      stepOneDecision: null,
      showPagination: true,
      registerform: {
        state: 0,
        isCommercial: '',
        call: 0,
        package: null,
        selectedSlot: {
          index: null,
          from: null,
          to: null,
          user: null
        },
        salutation: '',
        firstname: '',
        lastname: '',
        company: '',
        zip: '',
        city: '',
        email: '',
        phone: '',
        availability: '',
        privacy: false
      }
    }
  },
  components: {
    StepOne,
    StepTwo,
    StepThree,
    Error
  },
  methods: {
    async handleRequest () {
      const url = new URL(this.typo3ApiBase + 'step-one')
      url.searchParams.set('state', this.registerform.state)
      url.searchParams.set('license', this.license)
      url.searchParams.set('is-commercial', this.registerform.isCommercial)
      url.searchParams.set('salutation', this.registerform.salutation)
      url.searchParams.set('contact-firstname', this.registerform.firstname)
      url.searchParams.set('contact-lastname', this.registerform.lastname)
      url.searchParams.set('company', this.registerform.company)
      url.searchParams.set('zip', this.registerform.zip)
      url.searchParams.set('city', this.registerform.city)
      url.searchParams.set('email', this.registerform.email)
      url.searchParams.set('phone', this.registerform.phone)
      url.searchParams.set('availability', this.registerform.availability)
      url.searchParams.set('privacy', this.registerform.privacy)
      if (this.stepOneDecision === 2) {
        if (this.registerform.call) {
          url.searchParams.set('request-contact', this.registerform.call)
        } else {
          url.searchParams.set('selected-slot-from', this.registerform.selectedSlot.from)
          url.searchParams.set('selected-slot-to', this.registerform.selectedSlot.to)
          url.searchParams.set('selected-slot-user', this.registerform.selectedSlot.user)
        }
      }
      if (this.stepOneDecision === 3) {
        url.searchParams.set('trial', true)
        url.searchParams.set('package', this.registerform.package)
        url.searchParams.set('request-contact', true)
      }
      let self = this
      this.loading = true
      axios.post(url.href).then(() => {
        let formHash = ''
        switch (this.stepOneDecision) {
          case 1:
            formHash = '#InfomaterialForm'
            break
          case 2:
            formHash = '#AppointmentForm'
            break
          case 3:
            formHash = '#TrialForm'
            break
        }
        window.location.href = this.successPage + formHash
        self.loading = false
      }).catch(e => {
          console.log(e)
        self.step = 'Error'
        self.errorMessage = e.response.data.errors
        self.loading = false
      })
    }
  },
  created() {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    if (urlParams.get('decision')) {
      this.stepOneDecision = parseInt(urlParams.get('decision'))
      this.registerform.isCommercial = '1'
      this.showPagination = false
      this.step = 'StepThree'
    }
    if (urlParams.get('package')) {
      this.registerform.package = urlParams.get('package')
    }
  }
}
</script>
